import React from "react";
import { CustomSlider } from "../../../../components/CustomSlider/CustomSlider";
import { CategoryCard } from "./CategoryComponent/Category";
import { useHistory } from "react-router";
import { CategoriesSection } from "@core/types";
import cx from "classnames";
import { IonIcon } from "@ionic/react";
import { chevronForward } from "ionicons/icons";

type CategoriesProps = CategoriesSection;

const Categories = ({ ...categoriesSectionProps }: CategoriesProps) => {
  const history = useHistory();
  const { parentCategory, subCategories } = categoriesSectionProps.items;

  const handleOpenParentCategory = () => {
    if (parentCategory) {
      history.push(`/categories/${parentCategory.id}/subcategories`);
    }
  };

  const categoryTitle = categoriesSectionProps.title || parentCategory?.name;
  const hasSubCategories = subCategories && subCategories.length > 0;

  return (
    <div className="mt-2.5">
      <div onClick={handleOpenParentCategory} className={cx("mb-2.5 flex items-center gap-1", parentCategory && "")}>
        {categoryTitle}
        <IonIcon icon={chevronForward} className="text-base" />
      </div>
      <CustomSlider key={parentCategory?.id} containerClassName="flex gap-x-2 !p-0">
        {hasSubCategories
          ? subCategories?.map((subCategory) => <CategoryCard key={subCategory.id} category={subCategory} />)
          : parentCategory && <CategoryCard key={parentCategory.id} category={parentCategory} />}
      </CustomSlider>
    </div>
  );
};

export default Categories;
